import { useShellCreateAction } from '@ordo/ui/app-shell'
import { Badge } from '@ordo/ui/badge'
import { Button } from '@ordo/ui/button'
import { type Column, DataGrid } from 'compositions/DataGrid'
import { Page } from 'compositions/Page'
import { useContactGroups } from 'hooks/api'
import { Plus } from 'lucide-react'
import { Link, useNavigate } from 'react-router'
import type { ContactGroup } from 'types/communications'

const COLUMNS: Column<ContactGroup>[] = [
  {
    key: 'name',
    header: 'Name',
    sortable: true,
    filterable: true,
    render: (row) => (
      <Link to={`/lists/${row.id}`} className="text-foreground hover:underline">
        {row.name}
      </Link>
    ),
  },
  {
    key: 'dynamic',
    header: 'Type',
    mobile: 'aside',
    render: (row) => (
      <Badge variant={row.dynamic ? 'default' : 'secondary'}>{row.dynamic ? 'Dynamic' : 'Static'}</Badge>
    ),
  },
]

export function ListIndex() {
  const navigate = useNavigate()
  // On phones "New List" is the shell's floating + button; the header button is desktop only.
  useShellCreateAction({ label: 'New List', onCreate: () => navigate('/lists/new') })
  const { data: groups, loading } = useContactGroups()

  return (
    <Page>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-xl font-semibold">Lists</h1>
        <Button asChild className="hidden md:inline-flex">
          <Link to="/lists/new">
            <Plus className="h-4 w-4" />
            New List
          </Link>
        </Button>
      </div>
      <DataGrid
        columns={COLUMNS}
        data={groups ?? []}
        keyField="id"
        pageSize={20}
        loading={loading}
        storageKey="lists"
      />
    </Page>
  )
}
